// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#address select{-webkit-appearance:none;-moz-appearance:none;text-indent:1px;text-overflow:\"\"}#address input[type=number]{-moz-appearance:textfield}#address input::-webkit-inner-spin-button,#address input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
